import "./App.css";
import { resetScroll } from "./utils/scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Route, Routes } from "react-router";
import { useLocation } from "react-router";
import { useEffect, lazy, Suspense } from "react";
import MediaQuery from "react-responsive";
import { CursorProvider } from "./context/CursorContext";
import IPadCursor from "./components/iPadCursor/iPadCursor";

import { calculateAge } from "./utils/time";
import ContactAudit from "./components/ContactAudit/ContactAudit";
import BookingDialog from "./components/BookingDialog/BookingDialog";
import { TransitionProvider } from "./context/TransitionContext";

// Home is the landing page: bundled with the app so it renders without
// waiting on a second chunk. Everything else loads on demand.
import HomePage from "./pages/HomePage";

const Tuniscovery = lazy(() => import("./pages/Tuniscovery/Tuniscovery"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const UnidebNotes = lazy(() => import("./pages/UnidebNotes/UnidebNotes"));
const MENASYP = lazy(() => import("./pages/MENASYP/MENASYP"));
const Swatch = lazy(() => import("./pages/Swatch/Swatch"));
const Admin = lazy(() => import("./pages/Admin/Admin"));
const UIDapt = lazy(() => import("./pages/UIDapt/UIDapt"));
const BMW = lazy(() => import("./pages/BMW/BMW"));
const OurStoryPage = lazy(() => import("./pages/OurStory/OurStoryPage"));
const OurStory3Page = lazy(() => import("./pages/OurStory3/OurStory3Page"));
const OurStory4Page = lazy(() => import("./pages/OurStory4/OurStory4Page"));
const OurStory5Page = lazy(() => import("./pages/OurStory5/OurStory5Page"));
// const OurStory6Page = lazy(() => import("./pages/OurStory6/OurStory6Page"));

function App() {


  const useScrollRestoration = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      // Scroll to the top when the path changes (covers back/forward too)
      resetScroll();
    }, [pathname]);
  };

  useScrollRestoration();

  const age = calculateAge("2002-12-03");


  return (
    <HelmetProvider>
      <CursorProvider>
        <TransitionProvider>
          <div className="App">
            <Helmet>
              <title>
                Mohamed Ayoub Chebbi | Design Engineer for Human-Centered AI
                Products
              </title>
              <meta
                name="description"
                content={`Portfolio of Mohamed Ayoub Chebbi, a ${age} year old Design Engineer for Human-Centered AI Products.`}
              />
              <meta property="og:site_name" content="Mohamed Ayoub Chebbi" />
              <meta property="og:type" content="website" />
              <meta
                property="og:url"
                content="https://chebbimedayoub.com"
              />
              <meta
                property="og:image"
                content="https://chebbimedayoub.com/logo512.png"
              />
              <meta name="twitter:card" content="summary_large_image" />
              {/* <script src="https://unpkg.com/react-scan@0.3.3/dist/auto.global.js"></script> */}
            </Helmet>
            <MediaQuery query="(min-device-width: 700px)">
              <IPadCursor />
            </MediaQuery>
            <Suspense
              fallback={<div className="preloader-fallback">Loading...</div>}
            >
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/tuniscovery" element={<Tuniscovery />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/unidebnotes" element={<UnidebNotes />} />
                <Route path="/menasyp25" element={<MENASYP />} />
                <Route path="/swatch-mcp" element={<Swatch />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/uidapt" element={<UIDapt />} />
                <Route path="/bmw" element={<BMW />} />
                <Route path="/rouhi" element={<OurStoryPage />} />
                <Route path="/rouhi3" element={<OurStory3Page />} />
                <Route path="/rouhi4" element={<OurStory4Page />} />
                <Route path="/amalna5" element={<OurStory5Page />} />
                {/* <Route path="/ourstory6" element={<OurStory6Page />} /> */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
            <ContactAudit />
            <BookingDialog />
          </div>
        </TransitionProvider>
      </CursorProvider>
    </HelmetProvider>
  );
}

export default App;
